import { VideoMetadata } from 'shared-types/video-metadata';

import { NotPremiumError } from './errors';

export const isNotPremiumError = (
  payload: undefined | NotPremiumError,
): payload is NotPremiumError => {
  return payload instanceof NotPremiumError;
};

export interface FetchLyricsPayload {
  lyricsUrl: string;
  isStorageActivated: boolean;
}

export interface FetchColorPayload {
  colorSetting: string;
  isStorageActivated: boolean;
}

export interface FetchVideoMetadataAndNextResourcesPayload {
  getVideoMetadata: (videoFilename: string, userId: string) => Promise<VideoMetadata>;
  videoFilename: string;
  colorSetting: string;
  userId: string;
  isStorageActivated: boolean;
}
